import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import _ from 'lodash';
import { UseFormSetError } from 'react-hook-form';

import auth from 'src/repositories/auth';
import { FormValue } from 'src/containers/ForgotPassword/useForm';
import { useTranslation } from 'react-i18next';
import { STATUS_CODE } from 'src/constants/app';

export const apiKey = '/re-password/otp-sending' as const;

type UseForgotPass = {
  setError?: UseFormSetError<FormValue>;
  onSuccess?: (data) => void;
};

const useForgotPass = ({ setError, onSuccess }: UseForgotPass) => {
  const { t } = useTranslation();

  return useMutation<
    AxiosResponse<Response.ForgotPass>,
    AxiosError,
    Payload.ForgotPass
  >({
    mutationKey: [apiKey],
    mutationFn: (args) => auth.forgotPass(apiKey, args),
    retry: 0,
    async onSuccess(res) {
      onSuccess && onSuccess(res.data);
    },
    onError(err) {
      const errorCode = _.get(err, 'response.data.code');
      switch (errorCode) {
        case STATUS_CODE.FORGOT_PASS_EMAIL_NOT_EXIST:
          return (
            setError &&
            setError('email', {
              type: 'custom',
              message: t('message.E000032', { 0: t('label.email') }),
            })
          );
        case STATUS_CODE.FORGOT_PASS_SEND_OTP_TIMEOUT:
          return (
            setError &&
            setError('email', {
              type: 'custom',
              message: t('message.E000060'),
            })
          );
        case STATUS_CODE.FORGOT_PASS_SEND_DUPLICATE_DATA:
          return (
            setError &&
            setError('email', {
              type: 'custom',
              message: t('message.E000060'),
            })
          );
      }
    },
  });
};

export default useForgotPass;
